<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
                    <v-col cols="12" sm="12" md="12" >

                        <!--:label="`${'歡迎使用'+this.zoneName+'網路掛號系統為提供本服務，將請您輸入身分證字號、生日，您所提供的資料僅用於本院就醫及掛號使用，您是否同意提供'}`"-->
                            <v-checkbox
                                    hide-details
                                    class="v-input--dense"
                                    :disabled="disabled"
                                    @click="agree"
                                    v-model="checkAgree"
                            >
                                <template v-slot:label>
                                    <div class="privateFont">請勾選，如同意提供證件號碼/生日等資訊，以僅供本院掛號及就醫使用。</div> <!-- 證件號碼表示 所有可能的例如 身分證號/居留證/護照號碼等 110/07/22 -->
                                </template>
                            </v-checkbox>
                    </v-col>
</template>

<script>
    export default {
        name: "PersonalPermission",
        data() {
            return {
                checkAgree: false,

            }
        },
        props:{
            zoneName:{
                type:String,
                default:''
            },
            disabled:{
                type:Boolean,
                default:false
            }
        },
        created(){
        },
        methods:{
            agree(){
                this.$emit('agree',this.checkAgree);
            }
        }
    }
</script>

<style scoped>

    .privateFont{
        color: rgb(199, 6, 6);
        /*font-size: 1.5rem;*/
        /*line-height: 2rem;*/
        font-weight: bold;
        background:rgba(186,0,0,0.1);
        padding:5px;
        border-radius:4px;
        border:3px double rgba(186,0,0,0.2);
        box-shadow:1px 1px 1px rgba(128,128,128,0.5);
    }


</style>